<template>
	<div>
		<v-data-table
			v-if="itensSelecionadosCount > 0"
			:items="items"
			:items-per-page="paginacaoInterna.rowsPerPage"
			:page="paginacaoInterna.page"
			hide-default-footer
			:headers="colunas"
			hide-default-header
		>
			<template #body="{ items }">
				<v-expansion-panels class="py-2" multiple flat v-model="abertos">
					<v-expansion-panel v-for="item in items" :key="item.id" class="my-2" active-class="aberto" flat>
						<v-expansion-panel-header class="collapse-selecionados-header" ripple>
							{{ item.documento | azCpfCnpj }} - {{ item.razaoSocial }}
						</v-expansion-panel-header>
						<v-expansion-panel-content class="collapse-selecionados-conteudo">
							<listagem-interna-selecionados :item-selecionado="item"></listagem-interna-selecionados>
						</v-expansion-panel-content>
					</v-expansion-panel>
				</v-expansion-panels>
			</template>
		</v-data-table>
		<paginacao-tabela
			v-if="itensSelecionadosCount > 0"
			:total-paginas="totalPaginas"
			:total-itens="itensSelecionadosCount"
			:page.sync="paginacaoInterna.page"
			:rows-per-page.sync="paginacaoInterna.rowsPerPage"
			:show-rows-per-page="false"
		></paginacao-tabela>
		<template-listagem-vazia :textos="textos" :total-itens="itensSelecionadosCount"></template-listagem-vazia>
	</div>
</template>
<script>
import { TabelaColunaUtils } from '@/core/utils'
import { mapGetters, mapState } from 'vuex'
import { getterTypes } from '@/core/constants'
import PaginacaoListagem from '@/core/store/default/paginacaoListagem'
import ListagemInternaSelecionados from '@/views/pages/ata/gerar-ata/com-processo/modal/primeira-etapa/selecionados/listagem-interna-selecionados/ListagemInternaSelecionados.vue'

export default {
	name: 'selecionados-listagem',
	components: {
		ListagemInternaSelecionados,
	},
	data() {
		return {
			colunas: [new TabelaColunaUtils('razao', 'razaoSocial', '20%')],
			textos: {
				titulo: 'Não há nenhum item selecionado.',
			},
			paginacaoInterna: PaginacaoListagem(['id']),
			abertos: [],
		}
	},
	computed: {
		...mapGetters({
			itensSelecionadosCount: getterTypes.ITEM_ATA.ITENS_SELECIONADOS_COUNT,
		}),
		totalPaginas() {
			return Math.ceil(this.itensSelecionadosCount / this.paginacaoInterna.rowsPerPage)
		},
		...mapState({
			items: (state) => state.itemAta.itensParaAdicionarNaAta,
		}),
	},
	watch: {
		paginacaoInterna: {
			handler() {
				this.abertos = []
			},
			deep: true,
		},
	},
}
</script>
<style scoped lang="stylus">
estilo-padrao()
	border .1rem solid var(--v-grey-lighten1)
	border-radius .3rem

.v-expansion-panel--active.aberto > .v-expansion-panel-header
	min-height auto

.aberto .collapse-selecionados-header
	border-bottom-left-radius 0
	border-bottom-right-radius 0

.aberto .collapse-selecionados-conteudo
	border-top-color transparent
	border-top-left-radius 0
	border-top-right-radius 0

.collapse-selecionados-header
	background-color var(--v-grey-lighten4)
	color var(--v-grey-darken1)
	estilo-padrao()

.collapse-selecionados-conteudo
	estilo-padrao()
	padding-top: .5%;
</style>
